import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewDocFlowRow } from '../BirdviewDocFlowRow'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewDocFlowsWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  function handleOpen(item) {
    onNavigate(PROFILE_ROUTE_NAMES.docFlow(item.id))
  }

  function handleShowAll() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.docFlows))
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      isRefreshing={section.isRefreshing}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewDocFlowRow item={item} key={item.id} onOpen={handleOpen} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewDocFlowsWidget
